import React from 'react';
import { Route } from 'react-router-dom';


export const StateRoute = ({ component: Component, state: State, ...rest }) => (
    <Route {...rest} render={props => (<State><Component {...props} /></State>)} />
)